export default "__VITE_ASSET__psR8CrhC__"